export const TAX_SAVY_STATIC_URL = "https://www.taxsavysg.com/home";
